module.exports = __webpack_public_path__ + "img/thumb_image2.bd834156.jpg";